// extracted by mini-css-extract-plugin
module.exports = {"listTitle":"SectionBenefits_listTitle__iJM_b","listAfterTitle":"SectionBenefits_listAfterTitle__yqdt9"};